import styled from "styled-components/macro";

export const TypoH2 = styled.div`
  font-weight: 600;
  font-size: 32px;
  line-height: 40px;
`;

export const TypoSubheader = styled.div`
  font-weight: 400;
  font-size: 18px;
  line-height: 24px;
`;

export const TypoBodyRegular = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
`;
